import "core-js/modules/es.array.includes";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import Mlt from '@sprinx/react-mui-components/MultilineText';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
var componentSettings = {
  name: 'SxFieldPreviewNamed'
};
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      width: theme.spacing(20)
    },
    fullWidth: {
      width: '100%'
    },
    marginNone: {
      marginTop: 0,
      marginBottom: 0
    },
    marginNormal: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    marginDense: {
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5)
    }
  };
}, componentSettings);
/**
 * Zakladni komponenta pro zobrazeni hodnoty v readonly modu.
 */

function FieldPreviewNaked(_ref) {
  var align = _ref.align,
      pClasses = _ref.classes,
      className = _ref.className,
      color = _ref.color,
      display = _ref.display,
      fullWidth = _ref.fullWidth,
      InputProps = _ref.InputProps,
      margin = _ref.margin,
      size = _ref.size,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ["align", "classes", "className", "color", "display", "fullWidth", "InputProps", "margin", "size", "value"]);

  var classes = useStyles({
    classes: pClasses
  });
  var realClassName = clsx(classes.root, className, fullWidth && classes.fullWidth, {
    'none': classes.marginNone,
    'normal': classes.marginNormal,
    'dense': classes.marginDense
  }[margin]);
  var variantMap = {
    xsmall: 'caption',
    small: 'body2',
    normal: 'body1',
    large: 'h6',
    inherit: 'inherit'
  };
  var variant = variantMap[size] || 'body1';
  var component = ['initial', 'block'].includes(display) ? 'div' : 'span';
  return /*#__PURE__*/React.createElement(Typography, _extends({}, pickHTMLProps(rest), {
    align: align,
    className: realClassName,
    display: display,
    variant: variant,
    component: component,
    color: color
  }), InputProps && InputProps.startAdornment, /*#__PURE__*/React.createElement(Mlt, null, value), InputProps && InputProps.endAdornment);
}

FieldPreviewNaked.propTypes = {
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
  classes: PropTypes.shape({
    fullWidth: PropTypes.string,
    marginDense: PropTypes.string,
    marginNone: PropTypes.string,
    marginNormal: PropTypes.string,
    root: PropTypes.string
  }),
  className: PropTypes.string,

  /**
   * Barva zobrazovane hodnoty.
   */
  color: PropTypes.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),
  display: PropTypes.oneOf(['initial', 'block', 'inline']),

  /**
   * `true` pokud se ma komponenta zobrazit v cele dostupne sirce.
   */
  fullWidth: PropTypes.bool,

  /**
   * Custom vlastnosti `Input`.
   */
  InputProps: PropTypes.shape({
    endAdornment: PropTypes.node,
    startAdornment: PropTypes.node
  }),
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),
  size: PropTypes.oneOf(['xsmall', 'small', 'normal', 'large', 'inherit']),
  value: PropTypes.node
};
FieldPreviewNaked.defaultProps = {
  align: undefined,
  classes: undefined,
  className: undefined,
  color: 'initial',
  display: undefined,
  fullWidth: false,
  InputProps: undefined,
  margin: 'none',
  size: undefined,
  value: null
};
export default withThemeProps(componentSettings)(FieldPreviewNaked);